import React, { lazy, Suspense, useEffect } from 'react';
import useCodeNextWowStore from '@/stores/useCodeNextWowStore';
import { useLearnerScope } from '@/utils/learnerScope';
import { mergeWowSeen } from '@/utils/codeNextWow';
import { authFetch } from '@/services/projectService';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Lazy: the dialog pulls in Monaco and the flow diagram, and most page views
// never open it. App's main chunk should not pay for a rare moment.
const CodeNextWowDialog = lazy(() => import('./CodeNextWowDialog'));

// Mounted once in App, so a pass on any surface — Solution Page, builder,
// capstone board or story — opens the same dialog. Pages own their own
// ThemeProvider, so the theme is read from the `dark` class it sets on <html>.
export default function CodeNextWowHost() {
  const learner = useLearnerScope();
  // Once per learner per app load: learn which moments were already shown on any
  // device, so each of the five shows once per LEARNER, not once per browser.
  useEffect(() => {
    if (!learner) return undefined;
    let live = true;
    authFetch(`${API_URL}/api/codenext/wow-seen`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (live && data) mergeWowSeen(data.moments); })
      .catch(() => {});
    return () => { live = false; };
  }, [learner]);

  const wow = useCodeNextWowStore((s) => s.wow);
  const close = useCodeNextWowStore((s) => s.close);
  if (!wow) return null;
  const isDark = typeof document !== 'undefined'
    && document.documentElement.classList.contains('dark');
  return (
    <Suspense fallback={null}>
      <CodeNextWowDialog key={wow.moment} wow={wow} onClose={close} isDark={isDark} />
    </Suspense>
  );
}
